<mat-card class="card-mobile" appearance="outlined">
    <div class="card-location-image-container-mobile">
        <img class="card-location-image-mobile" src="{{photo}}">
    </div>
    <div class="card-location-body-mobile"> 
      <mat-card-content class="card-location-content-mobile">
      <div class="card-location-content-container-mobile">
            <mat-card-title class="card-location-title-mobile">{{name}}</mat-card-title>
            <div *ngIf="isOpen==true">
                <div class="card-location-wait-time-mobile" *ngIf="waitTime!=null">
                    <div class="card-location-as-soon-as-mobile">
                        {{soonAsText}}
                    </div>
                    <div class="card-location-availability-mobile">
                        {{waitTimeStr}}
                    </div>
                </div>
            </div>
            <div *ngIf="isOpen!=true" class="card-location-wait-time-mobile">
                <div class="card-location-availability-mobile">
                    {{openTomorrow}}
                </div>
            </div>
        </div>
        </mat-card-content>
        <mat-card-actions class="card-location-actions-mobile">
            <div *ngIf="distance != null" class="card-provider-detail-bottom-left">
                <svg width="9" height="8.86" viewBox="0 0 9 8.86" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.85468 0L5.21832 9.12723L3.99545 5.13755L0.0221554 4.05578L8.85468 0Z" fill="#959595"/>
                </svg>
                {{distance}} {{milesAwayText}}
            </div>
            <div *ngIf="distance == null" class="card-provider-detail-bottom-left"></div>
            <div *ngIf="isOpen==true">
                <div *ngIf="nextAvailability!=null">
                    <button mat-button class="action-button-primary" style="height: 32px; width: 82px;" (click)="reserveNow()">{{reserveText}}</button>
                </div>
                <div *ngIf="nextAvailability==null">
                    <button mat-button class="action-button-primary" style="min-height: 32px; min-width: 110px;" (click)="walkinNow()">{{walkinText}}</button>
                </div>
            </div>
            <div *ngIf="isOpen!=true">
                <button mat-button class="action-button-primary" style="min-height: 32px; min-width: 115px; font-size: 13px;" (click)="vucNow()">{{vucText}}</button>
            </div>
        </mat-card-actions>
    </div>
</mat-card>
